import { useQuery } from "hooks/useQuery";
import { getStockMovers } from "../service";

export const useStockMoversList = (type) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["stockMoversList", type],
    queryFn: async () => {
      const response = await getStockMovers({ type });
      return response;
    },
    enabled: Boolean(type),
  });

  return {
    isLoading,
    moversData: data || [],
    refetch,
  };
};
